// No React import needed with modern JSX transform
import {
  Avatar,
  AvatarImage,
  AvatarFallback,
} from "@/components/ui/atoms/avatar";

const AvatarTest = () => {
  const handleEditClick = () => {
    alert("Edit avatar clicked");
  };

  return (
    <div className="p-8 bg-neutral-10 min-h-screen">
      <h1 className="text-2xl font-bold text-primary-indigo-600 mb-6">
        Avatar Component Test
      </h1>

      <section className="mb-8">
        <h2 className="text-lg font-medium text-primary-indigo-600 mb-4">
          Small Avatars (48x48)
        </h2>
        <div className="flex flex-wrap gap-6 items-center">
          {/* Small avatar with initials */}
          <div className="flex flex-col items-center">
            <Avatar size="sm">
              <AvatarFallback>SR</AvatarFallback>
            </Avatar>
            <p className="mt-2 text-sm text-neutral-600">Initials</p>
          </div>

          {/* Small avatar with image */}
          <div className="flex flex-col items-center">
            <Avatar size="sm">
              <AvatarImage src="https://github.com/shadcn.png" alt="User" />
              <AvatarFallback>CN</AvatarFallback>
            </Avatar>
            <p className="mt-2 text-sm text-neutral-600">Image</p>
          </div>

          {/* Small avatar with edit button */}
          <div className="flex flex-col items-center">
            <Avatar size="sm" showEditButton onEditClick={handleEditClick}>
              <AvatarFallback>SR</AvatarFallback>
            </Avatar>
            <p className="mt-2 text-sm text-neutral-600">With Edit</p>
          </div>

          {/* Small avatar with image and edit button */}
          <div className="flex flex-col items-center">
            <Avatar size="sm" showEditButton onEditClick={handleEditClick}>
              <AvatarImage src="https://github.com/shadcn.png" alt="User" />
              <AvatarFallback>CN</AvatarFallback>
            </Avatar>
            <p className="mt-2 text-sm text-neutral-600">Image with Edit</p>
          </div>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-lg font-medium text-primary-indigo-600 mb-4">
          Large Avatars (72x72)
        </h2>
        <div className="flex flex-wrap gap-6 items-center">
          {/* Large avatar with initials */}
          <div className="flex flex-col items-center">
            <Avatar size="lg">
              <AvatarFallback>SR</AvatarFallback>
            </Avatar>
            <p className="mt-2 text-sm text-neutral-600">Initials</p>
          </div>

          {/* Large avatar with image */}
          <div className="flex flex-col items-center">
            <Avatar size="lg">
              <AvatarImage src="https://github.com/shadcn.png" alt="User" />
              <AvatarFallback>CN</AvatarFallback>
            </Avatar>
            <p className="mt-2 text-sm text-neutral-600">Image</p>
          </div>

          {/* Large avatar with edit button */}
          <div className="flex flex-col items-center">
            <Avatar size="lg" showEditButton onEditClick={handleEditClick}>
              <AvatarFallback>SR</AvatarFallback>
            </Avatar>
            <p className="mt-2 text-sm text-neutral-600">With Edit</p>
          </div>

          {/* Large avatar with image and edit button */}
          <div className="flex flex-col items-center">
            <Avatar size="lg" showEditButton onEditClick={handleEditClick}>
              <AvatarImage src="https://github.com/shadcn.png" alt="User" />
              <AvatarFallback>CN</AvatarFallback>
            </Avatar>
            <p className="mt-2 text-sm text-neutral-600">Image with Edit</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AvatarTest;
